import clsx from 'clsx';
import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props extends Pick<DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>, 'className'> {
  children: ReactNode;
}

export const ContainerSection: React.FC<Props> = ({ children, className }) => (
  <section data-testid='container-section' className={twMerge(clsx('mx-auto w-full px-6 lg:container 2xl:max-w-7xl', className))}>
    {children}
  </section>
);
